module.exports = __webpack_public_path__ + "static/media/icon_income.2ddc64cb.svg";